export function timer(timeInSecs: number, cb: (currTime: number) => void) {
    let t = timeInSecs;
    cb(t);
    t--;
    const id = setInterval(() => {
        if (t > -1) {
            cb(t);
            t--;
        } else {
            clearInterval(id);
        }
    }, 1000);
    return id;
}
